
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((|10|92)1|427|535|638)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
